import React from 'react';
import styles from './AuthWelcomeShell.module.css';
import WelcomeNavBar from '../Welcome/WelcomeNavBar';
import sliderDec from '../../assets/img/landing/slider-dec.png';

const DEFAULT_LEFT = {
  heading: 'Trace your roots',
  description:
    'Your family story, securely preserved on iGiTREE.',
};

export interface AuthWelcomeShellProps {
  children: React.ReactNode;
  pageLabel: string;
  leftHeading?: string;
  leftDescription?: string;
}

const AuthWelcomeShell: React.FC<AuthWelcomeShellProps> = ({
  children,
  pageLabel,
  leftHeading,
  leftDescription,
}) => {
  const lh = leftHeading ?? DEFAULT_LEFT.heading;
  const ld = leftDescription ?? DEFAULT_LEFT.description;

  return (
    <div className={styles.authTheme}>
      <WelcomeNavBar />
      <div className={styles.split}>
        <aside className={styles.leftColumn}>
          <div className={styles.blobBg}>
            <div className={styles.blobMain} />
            <div className={styles.blobWave} />
            <div className={styles.blobCircle} />
            <div className={`${styles.ghostSq} ${styles.ghostSq1}`} />
            <div className={`${styles.ghostSq} ${styles.ghostSq2}`} />
            <div className={`${styles.ghostSq} ${styles.ghostSq3}`} />
            <div className={`${styles.ghostSq} ${styles.ghostSq4}`} />
          </div>
          <div className={styles.leftUpper}>
            <img
              src={sliderDec}
              alt=""
              className={styles.leftHeroImg}
              width={320}
              height={280}
            />
          </div>
          <div className={styles.leftContent}>
            <p className={styles.pageEyebrow}>{pageLabel}</p>
            <h2 className={styles.leftHeading}>{lh}</h2>
            <p className={styles.leftDescription}>{ld}</p>
          </div>
        </aside>

        <div className={styles.rightColumn}>
          <div className={styles.formSurface}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default AuthWelcomeShell;
